import { Check } from '@mui/icons-material'
import { FormInputCheckbox } from 'feature/formComponents'
import { useEditUserNoticeDataMutation } from 'feature/user/redux/user.api'
import { useSetNotice } from 'hooks/useSetNotice'
import {
  FieldValues,
  SubmitHandler,
  useFormContext,
  useFormState,
} from 'react-hook-form'
import { Button, Link } from 'ui'
import { LoaderInCentalPosition } from 'widget'
import { Severity } from 'widget/Notifications'

import style from './NoticeSettingsForm.module.scss'
// страница настройки уведомлений
export const NoticeSettingsForm = () => {
  const { handleSubmit, reset } = useFormContext()
  const { isDirty } = useFormState()
  const [sendNotice, { isLoading: isEditDataLoading }] =
    useEditUserNoticeDataMutation()
  const setNotice = useSetNotice()

  const onSubmit: SubmitHandler<FieldValues> = formData => {
    sendNotice({
      isSmsOn: formData.isSmsOn,
      isEmailOn: formData.isEmailOn,
      isWhatsAppOn: formData.isWhatsAppOn,
      isTelegramOn: formData.isTelegramOn,
      agreeSubscribeAdvertising: formData.agreeSubscribeAdvertising,
    })
      .then(res => {
        if ('error' in res) {
          //@ts-ignore
          const error = res.error.data
          setNotice(error.message || 'Ошибка сохранения данных', Severity.error)
          return
        }

        setNotice('Данные успешно сохранены', Severity.success)
      })
      .catch(() => {
        setNotice('Ошибка сохранения данных', Severity.error)
      })
      .finally(() => reset(formData))
  }

  return (
    <form className={style.form} noValidate onSubmit={handleSubmit(onSubmit)}>
      <div className={style.checkboxes}>
        <FormInputCheckbox
          name='isEmailOn'
          label='Электронная почта'
          checkboxProps={{ 'data-testid': 'notice-email' }}
        />
        <FormInputCheckbox
          name='isSmsOn'
          label='СМС'
          checkboxProps={{ 'data-testid': 'notice-sms' }}
        />
        <FormInputCheckbox
          name='isWhatsAppOn'
          label='WhatsApp'
          checkboxProps={{ 'data-testid': 'notice-whatsapp' }}
        />
        <FormInputCheckbox
          name='isTelegramOn'
          label='Telegram'
          checkboxProps={{ 'data-testid': 'notice-telegram' }}
        />
        <FormInputCheckbox
          name='agreeSubscribeAdvertising'
          label={
            <div className={style.personalAgree}>
              <span>Согласен на </span>
              <Link href='/advagreement' underline='hover' target='_blank'>
                получение рекламной рассылки
              </Link>
            </div>
          }
          checkboxProps={{ 'data-testid': 'notice-adv-agree' }}
        />
      </div>
      <Button
        startIcon={<Check />}
        variant='contained'
        type='submit'
        color='primary'
        className={style.submitButton}
        disabled={isEditDataLoading || !isDirty}
        data-testid='notice-submit'
      >
        {isEditDataLoading && (
          <LoaderInCentalPosition className={style.loader} />
        )}
        Сохранить изменения
      </Button>
    </form>
  )
}
